import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Buttons, CancelButton, ModalCard } from '~/components';
import { Card as ModalCardInner } from '~/components/ModalCard';
import { useApi, useToast, useWorkspace } from '~/contexts';

const Modal = styled(ModalCard)`
  ${ModalCardInner} {
    width: 30rem;
  }
`;

export default function EnableAssistantModal({ onClose, onEnabled }) {
  const api = useApi();
  const toast = useToast();
  const { workspace, updateWorkspace } = useWorkspace();
  const [isLoading, setIsLoading] = useState(false);

  const handleEnable = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.www.workspaces(workspace.id).features.activate('assistant');
      updateWorkspace({ features: data });
      toast.success('The Ruddr Assistant feature has been enabled.');
      onEnabled();
    } catch (error) {
      toast.error(error.message || 'Something went wrong.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title="Enable Ruddr Assistant" onClose={onClose}>
      <ModalCard.Body>
        The Ruddr Assistant feature is not currently enabled for your workspace. Would you like to enable it now?
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <Button isLoading={isLoading} onClick={handleEnable}>
            Enable
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </Modal>
  );
}
